import {
  api_ValidateSalesOrderBeforePlacing,
  api_SaveSalesOrder,
} from "../connection/api/api-checkout";
import { dto_selected_final_merchant_or_product } from "../classes/dto-selected-merchant-or-product";
import { dto_Customer, dto_CustomerAddress } from "../classes/dto-customer";
import { BuildVersion, CSP, currentver, ENCRYPT_STORAGE } from "../config/config";
import { dto_cart_checkout } from "../classes/dto-cart-checkout";
import { PT_ORDERSTATUS } from "../routes/stack/paths/pt-cart";
import { ToastMessage } from "../components/toast-notification/toast";
import { dto_common } from "../classes/dto-common";
import { PT_ORDERS } from "../routes/stack/paths/pt-orders";
import { GET_CART } from "../database/get-stored-data";
import { getOrderDineType } from "./dine-type";
import { applyLocalSalesOrderCalculation } from "./local-order-calculation";
import { TABLE_NO } from "../database/store-names";

export const placeOrderFromStoredCheckout = async ({
  bankTransferGuid = "",
  navigate,
}) => {
  if (!dto_cart_checkout || dto_cart_checkout.Cart.length <= 0) {
    await ToastMessage(3, "No items in your cart");

    return;
  }

  const rawCart = (await GET_CART()) || [];
  await applyLocalSalesOrderCalculation({
    cart: rawCart,
    isChangePromo: false,
    customerPromoCount: 0,
  });

  let rs = await api_ValidateSalesOrderBeforePlacing();
  if (JSON.parse(rs) !== "SUCCESS") {
    navigate(PT_ORDERS);
    setTimeout(() => {
      ToastMessage(3, rs);
    }, 0);
    return;
  }

  if (dto_common.IsCash === 4 && bankTransferGuid === "") {
    await ToastMessage(3, "Something went wrong with image upload");
    return;
  }

  const SCHEDULEDORDER = dto_common.SCHEDULEDDATE !== "";
  if (parseInt(dto_common.DineType) !== 4) {
    dto_CustomerAddress.AddressGuid = 0;
  }
  const tableNo =
    CSP === "DT"
      ? String(ENCRYPT_STORAGE.getItem(TABLE_NO) || "").trim()
      : "";
  const dineTypeForOrder = getOrderDineType({
    dineType: dto_common.DineType,
    tableNo,
  });

  const InvSaveData = {
    SERVICENAME: "SaveSalesOrder",
    MOBILEPOSHEADER: [
      {
        GUIDAddress: parseInt(dto_CustomerAddress.AddressGuid),
        IsCash: parseInt(dto_common.IsCash),
        DeliveryCustomer: dto_Customer.CusName,
        DeliveryPhoneNo: dto_Customer.PhoneNo,
        CSID: parseInt(dto_Customer.CSID),
        Company: "",
        SubTotal: parseFloat(dto_cart_checkout.SubTotal),
        TaxTotal: parseFloat(dto_cart_checkout.TaxTotal),
        ServiceCharge: parseFloat(dto_cart_checkout.ServiceCharge),
        CusName: dto_Customer.CusName,
        Comments:
          typeof dto_cart_checkout.Comment === "string"
            ? dto_cart_checkout.Comment
            : "",
        Add1: dto_CustomerAddress.DefaultAdd1,
        Add2: dto_CustomerAddress.DefaultAdd2,
        Add3: dto_CustomerAddress.DefaultAdd3,
        PhoneNo: dto_Customer.PhoneNo,
        RowDiscountTotal: parseFloat(dto_cart_checkout.RowDiscountTotal),
        Total: parseFloat(dto_cart_checkout.Total),
        DiscountTotal: parseFloat(dto_cart_checkout.DiscountTotal),
        MID: parseInt(dto_selected_final_merchant_or_product.MID),
        Merchant: dto_selected_final_merchant_or_product.Merchant,
        DeviceName: "Web",
        DeliveryZoneID: parseInt(dto_common.DeliveryZoneID),
        ReleaseVersion: BuildVersion + " - " + currentver,
        DineType: dineTypeForOrder,
        TableNo: tableNo,
        DiscountPersentage: parseFloat(dto_cart_checkout.DiscountPersentage),
        BankTransferImageGUID: bankTransferGuid,
        PromoGUID: parseInt(dto_cart_checkout.PromoGuid),
        PromoCode: dto_cart_checkout.PromoCODE,
        PUBLICIP: "192.168.1.1",
      },
    ],
    SQLDETAILSTRING: JSON.stringify(dto_cart_checkout.Cart),
    VERSION: BuildVersion,
    CSP: CSP,
    COUNTRYCODE: dto_common.NatvieCountry,
    COORDINATES: dto_common.CurrentCordinate,
    XMLTAXDOC: JSON.stringify(dto_cart_checkout.XMLTaxDoc),
    SCHEDULEDORDER: SCHEDULEDORDER,
    SCHEDULEDDATE: dto_common.SCHEDULEDDATE,
    SCHEDULEDTIME: dto_common.SCHEDULEDTIME,
    IPGGUID: "0",
    GUID: 0,
    REFPOSID: parseInt(0),
  };

  let data = await api_SaveSalesOrder(JSON.stringify(InvSaveData));
  let objResponse = JSON.parse(data.replace("#", ""));

  let status = "";
  let iserorr = "";
  if (objResponse.Error === null) {
    status = objResponse.GUNO;
    iserorr = "rquaste";
  } else {
    status = objResponse.Error;
    iserorr = "lquasfe";
  }
  navigate(
    PT_ORDERSTATUS.replace(":status", status).replace(":iserorr", iserorr),
  );
};
